import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Suppress benign ResizeObserver loop error (can fire when observer callback triggers layout)
const resizeObserverErr = "ResizeObserver loop completed with undelivered notifications";
window.addEventListener("error", (e) => {
  if (e.message === resizeObserverErr) {
    e.stopImmediatePropagation();
    return true;
  }
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
